(() => {
  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const initPurchase = (root) => {
    if (!root || root.dataset.cvS4E10Ready === 'true') return;
    root.dataset.cvS4E10Ready = 'true';

    const form = root.querySelector('[data-cv-s4-e10-product-form]');
    if (!form) return;

    const quantity = form.querySelector('[data-cv-s4-e10-quantity]');
    const minus = form.querySelector('[data-cv-s4-e10-quantity-minus]');
    const plus = form.querySelector('[data-cv-s4-e10-quantity-plus]');
    const mainButton = form.querySelector('[data-cv-s4-e10-add]');
    const variantInput = form.querySelector('[data-cv-s4-e10-variant-input]');
    const price = form.querySelector('[data-cv-s4-e10-price]');
    const compare = form.querySelector('[data-cv-s4-e10-compare]');
    const sku = form.querySelector('[data-cv-s4-e10-sku]');
    const hero = root.querySelector('[data-cv-s4-e10-hero-image]');
    const variantDataNode = root.querySelector('[data-cv-s4-e10-variants]');
    let variants = [];

    try {
      variants = JSON.parse(variantDataNode?.textContent || '[]');
    } catch (_error) {
      variants = [];
    }

    const clampQuantity = (next) => {
      if (!quantity) return;
      const min = Number(quantity.min || 1);
      const max = quantity.max ? Number(quantity.max) : Number.POSITIVE_INFINITY;
      const step = Number(quantity.step || 1);
      const normalized = Math.max(min, Math.min(max, next));
      quantity.value = String(min + Math.round((normalized - min) / step) * step);
      quantity.dispatchEvent(new Event('change', { bubbles: true }));
    };

    minus?.addEventListener('click', () => clampQuantity(Number(quantity?.value || 1) - Number(quantity?.step || 1)));
    plus?.addEventListener('click', () => clampQuantity(Number(quantity?.value || 1) + Number(quantity?.step || 1)));

    const selectedOptions = () => Array.from(form.querySelectorAll('[data-cv-s4-e10-option]:checked')).map((input) => input.value);
    const updateVariant = () => {
      if (!variants.length || !variantInput) return;
      const options = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        mainButton?.setAttribute('disabled', '');
        mainButton?.setAttribute('aria-disabled', 'true');
        syncFinal();
        return;
      }

      variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price, root.dataset.currency);
      if (compare) {
        const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !onSale;
        compare.textContent = onSale ? money(variant.compare_at_price, root.dataset.currency) : '';
      }
      if (sku) sku.textContent = variant.sku || '';
      if (hero && variant.image) {
        hero.src = variant.image;
        hero.alt = variant.image_alt || hero.alt;
      }
      if (mainButton) {
        mainButton.disabled = !variant.available;
        mainButton.setAttribute('aria-disabled', String(!variant.available));
        const label = mainButton.querySelector('[data-cv-s4-e10-add-label]');
        if (label) label.textContent = variant.available ? mainButton.dataset.readyLabel : mainButton.dataset.unavailableLabel;
      }
      syncFinal(variant);
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };

    form.querySelectorAll('[data-cv-s4-e10-option]').forEach((input) => input.addEventListener('change', updateVariant));

    const syncFinal = (variant) => {
      document.querySelectorAll(`[data-cv-s4-e10-final][data-product-id="${root.dataset.productId}"]`).forEach((section) => {
        const finalButton = section.querySelector('[data-cv-s4-e10-final-add]');
        const finalPrice = section.querySelector('[data-cv-s4-e10-final-price]');
        const current = variant || variants.find((item) => String(item.id) === String(variantInput?.value));
        if (finalPrice && current) finalPrice.textContent = money(current.price, root.dataset.currency);
        if (finalButton && mainButton) {
          finalButton.disabled = mainButton.disabled;
          finalButton.setAttribute('aria-disabled', String(mainButton.disabled));
          finalButton.setAttribute('aria-busy', mainButton.getAttribute('aria-busy') || 'false');
        }
      });
    };

    form.addEventListener('submit', () => {
      if (!mainButton || mainButton.disabled) return;
      mainButton.setAttribute('aria-busy', 'true');
      const label = mainButton.querySelector('[data-cv-s4-e10-add-label]');
      if (label) label.textContent = mainButton.dataset.loadingLabel;
      window.requestAnimationFrame(syncFinal);
    });

    if (mainButton) new MutationObserver(() => syncFinal()).observe(mainButton, { attributes: true, attributeFilter: ['disabled', 'aria-busy'] });
    syncFinal();
  };

  const initFaq = (section) => {
    if (!section || section.dataset.cvS4E10FaqReady === 'true') return;
    section.dataset.cvS4E10FaqReady = 'true';
    const allowMultiple = section.dataset.allowMultiple === 'true';
    section.querySelectorAll('details').forEach((item) => {
      const summary = item.querySelector('summary');
      const syncExpandedState = () => {
        if (summary) summary.setAttribute('aria-expanded', String(item.open));
      };
      syncExpandedState();
      item.addEventListener('toggle', () => {
        syncExpandedState();
        if (!item.open || allowMultiple) return;
        section.querySelectorAll('details[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-cv-s4-e10-purchase]').forEach(initPurchase);
    scope.querySelectorAll('[data-cv-s4-e10-faq]').forEach(initFaq);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
